import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

export const DropdownTitle = ({
  children,
  dropdownTitle,
  additionalElement,
}) => {
  const { getTextByKey } = useContent();
  return (
    <div className={`dropdown-button  `}>
      {additionalElement ? additionalElement : null}
      <div className="dropdown-title">
        {getTextByKey(dropdownTitle)
          ? getTextByKey(dropdownTitle)
          : dropdownTitle}
      </div>
      {children && <div className="dropdown-icons">{children}</div>}
    </div>
  );
};
